<template>
  <div class="movie-hall page">
    <van-nav-bar
        class="nav-bar"
        :title="$t('视频影院')"
    />
    <van-tabs v-model="active" animated swipeable @change="OnChange">
      <van-tab v-for="(v,key) in videolitem" :key="key" :name="v.key" :title="v.name"></van-tab>
    </van-tabs>
    <swiper ref="swiper" :options="videoSwiperOption" class="video_swiper" @slideChange="itemChange">
      <swiper-slide v-for="(v,key) in videolitem" :key="key">
        <div class="movie-list-tab">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="hot-recommend-div">
              <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :finished-text="$t('没有更多了')"
                  @load="onLoad"
              >
                <div class="list-item">
                  <div v-for="(v,key) in videolist" :key="key" class="movie-list-item" @click="toPlayVideo(v.id)">
                    <van-image :src="v.vod_pic" class="cover_img" round>
                      <template v-slot:loading>
                        <van-loading type="circular"/>
                      </template>
                    </van-image>
                    <div class="movie-list-item-bottom">
                      <div class="movie-time-div">
                        <span>{{ v.vod_name }}</span>
                        <span>{{ $t('播放') }}:{{ v.count }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </van-list>

            </div>
          </van-pull-refresh>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {Toast} from 'vant';

export default {
  data() {
    return {
      active: 0,
      isLoading: false,
      count: 0,
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      videolist: [],
      number: 0,
      page: 0,
      videoSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      }
    };
  },
  methods: {
    getVideoClass() {
      this.$http({
        method: 'get',
        url: 'video_class'
      }).then(res => {
        this.videolitem = res.data;
      })
    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/PlayVideo?id=' + id})
      }

    },
    itemChange() {
      this.active = this.$refs.swiper.swiper.activeIndex
      this.OnChange()
    },
    getVideoList() {
      this.$http({
        method: 'get',
        data: {id: this.active, page: this.page},
        url: 'video_list'
      }).then(res => {
        this.videolist = this.videolist.concat(res.data.data);
        this.count = res.data.count;
        this.page++;

      })
    },
    onLoad() {
      this.getVideoList();
      let timer = setTimeout(() => {
        if (this.refreshing) {
          this.videolist = [];
          this.refreshing = false;
        }
        this.loading = false;
        if (this.videolist.length === this.count) {
          this.finished = true;
        }
        this.finished && clearTimeout(timer);//清除计时器
      }, 500);
    },
    OnChange() {
      this.videolist = [];
      this.number = 0;
      this.page = 0;
      this.count = 0;
      this.getVideoList();//获取视频列表

    },
    onRefresh() {
      setTimeout(() => {
        this.finished = false;
        this.loading = true;
        this.onLoad();
        this.isLoading = false;
        Toast(this.$t("刷新成功") + '！');
      }, 500);
    },
  },
  created() {
    this.getVideoClass();//获取视频类目
    this.OnChange()
  }
};
</script>

<style lang='less' scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.nav-bar {
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  height: 100px;

}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.movie-hall {
  display: flex;
  flex-direction: column;
  bottom: 100px;
  background: #f2f2f5;
}

::v-deep .van-tabs__nav {
  background: linear-gradient(to right, rgb(126, 86, 120), rgb(230, 195, 161));
}

::v-deep .van-tab {
  color: #ffffff;
  font-size: 30px;
}

::v-deep .van-tabs__line {
  bottom: 15px;
  width: 55px;
  height: 7px;
  border-radius: 0px;
  background-color: #ffffff;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.video_swiper {
  width: 100%;
  flex: 1;

  .swiper-slide {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 100%;
    justify-content: center;
    height: 100%;
    position: relative;
    transition-property: transform;
  }
}

.movie-list-tab {
  overflow: auto;
  height: 100%;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000;
  font-size: 35px;
}

.movie-list-tab .hot-recommend-div {
  height: 100%;
  margin: 10px auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  //overflow: auto;
}

.list-item {
  display: flex;
  width: calc(100% - 50px);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.list-item .movie-list-item:nth-child(odd) {
  margin-right: 20px;
}

.movie-list-item .cover_img {
  border-radius: 20px;
  width: 335px;
  height: 290px;
}

.movie-list-item {
  margin-bottom: -10px;
}

.list-item .movie-list-item-bottom {
  position: relative;
  width: 335px;
  bottom: 42px;
}

.list-item .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.list-item .movie-list-item-bottom > div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-item .movie-list-item-bottom .movie-time-div .van-count-down {
  color: #fff;
}

.list-item .movie-list-item .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 180px;
  padding-left: 8px;
  font-size: 25px;
}

.list-item .movie-time-div {
  color: #fff;
  border-radius: 0 0 20px 20px;
  height: 35px;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  // Tab标签PC端适配
  ::v-deep .van-tabs--line .van-tabs__wrap {
    height: 57px; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-tab {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  ::v-deep .van-tabs__line {
    bottom: 9px; /* 15px * 0.5733 ≈ 9px */
    width: 32px; /* 55px * 0.5733 ≈ 32px */
    height: 4px; /* 7px * 0.5733 ≈ 4px */
  }

  ::v-deep .van-tabs__wrap--scrollable .van-tab {
    padding: 0 13px; /* 23px * 0.5733 ≈ 13px */
  }

  // 视频列表PC端适配
  .movie-list-tab {
    overflow-y: auto !important; /* PC端恢复滚动功能 */
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch;
    height: calc(100vh - 114px) !important; /* 导航栏57px + Tab 57px = 114px，确保有固定高度 */
    position: relative; /* 确保滚动容器定位正确 */
  }

  .movie-list-tab .hot-recommend-div {
    margin: 6px auto; /* 10px * 0.5733 ≈ 6px */
    height: auto; /* PC端改为auto，让内容自然撑开 */
    min-height: calc(100vh - 120px); /* 确保最小高度，让滚动能触发 */
  }

  // PC端确保van-list能检测到滚动容器的滚动
  ::v-deep .van-pull-refresh__track {
    min-height: 100%; /* 确保内容足够高 */
  }

  ::v-deep .van-list {
    min-height: 100%; /* 确保内容足够高 */
  }

  .list-item {
    width: calc(100% - 19px); /* 50px * 0.5733 ≈ 29px */
    margin: 6px auto; /* 10px * 0.5733 ≈ 6px */
  }

  .list-item .movie-list-item:nth-child(odd) {
    margin-right: 11px; /* 20px * 0.5733 ≈ 11px */
    margin-bottom: 0px;
  }

  .movie-list-item .cover_img {
    border-radius: 11px; /* 20px * 0.5733 ≈ 11px */
    width: 192px; /* 335px * 0.5733 ≈ 192px */
    height: 166px; /* 290px * 0.5733 ≈ 166px */
  }

  .list-item .movie-list-item-bottom {
    width: 192px; /* 335px * 0.5733 ≈ 192px */
    bottom: 24px; /* 42px * 0.5733 ≈ 24px */
  }

  .list-item .movie-list-item .movie-time-div span:first-child {
    width: 103px; /* 180px * 0.5733 ≈ 103px */
    padding-left: 5px; /* 8px * 0.5733 ≈ 5px */
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }

  .list-item .movie-list-item .movie-time-div span:last-child {
    font-size: 13px; /* 假设22px * 0.5733 ≈ 13px */
    padding-right: 5px; /* 8px * 0.5733 ≈ 5px */
  }

  .list-item .movie-time-div {
    border-radius: 0 0 11px 11px; /* 20px * 0.5733 ≈ 11px */
    height: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  // 下拉刷新PC端适配
  ::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  // 列表完成提示PC端适配
  ::v-deep .van-list__finished-text {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
    padding-bottom: 11px; /* 20px * 0.5733 ≈ 11px */
  }
}
</style>
